<template>
    <b-row>
        <loading :active.sync="isLoading"></loading>
        <b-col md="12">
            <b-card>
                <div slot="header">
                    <strong>{{user.username}} {{ $t('profile.account_settings') }}</strong>
                </div>
                <b-form @submit="update($event)">
                    <!--
                        <b-form-group
                          :label="$t('profile.id')"
                          label-for="identification"
                          :label-cols="3"
                          >
                          <b-form-input plaintext redonly id="identification" type="text" :value="form.id"></b-form-input>
                        </b-form-group>

                        <b-form-group
                          :label="$t('profile.parent_user')"
                          label-for="parent_id"
                          :label-cols="3"
                          >
                          <b-form-input plaintext redonly id="parent_id" type="text" :value="user.id"></b-form-input>
                        </b-form-group>
                        -->
                    <b-form-group
                        :description="$t('profile.first_name')"
                        :label="$t('profile.first_name_description')"
                        label-for="firstname"
                        :label-cols="3"
                        >
                        <b-form-input id="firstname" type="text" autocomplete="name" v-model.trim="$v.form.first_name.$model"></b-form-input>
                    </b-form-group>
                    <b-form-group
                        :description="$t('profile.last_name')"
                        :label="$t('profile.last_name_description')"
                        label-for="lastname"
                        :label-cols="3"
                        >
                        <b-form-input id="lastname" type="text" autocomplete="name" v-model.trim="$v.form.last_name.$model"></b-form-input>
                    </b-form-group>
                    <b-form-group
                        :label="$t('profile.whatsapp_nr')"
                        label-for="whatsapp_nr"
                        :label-cols="3"
                        >
                        <b-form-input id="whatsapp_nr" type="text"  v-model.trim="$v.form.whatsapp_nr.$model" ></b-form-input>
                    </b-form-group>
                    <!--
                        <b-form-group
                          :label="$t('profile.resident_id')"
                          label-for="resident_id"
                          :label-cols="3"
                          >
                          <b-form-input id="resident_id" type="text" v-model.trim="$v.form.identification.$model"></b-form-input>
                        </b-form-group>

                        <b-form-group
                          label="Birthday" label-for="date"
                          :label-cols="3"
                          >
                          <b-form-input type="date" id="date"  v-model.trim="$v.form.dob.$model"></b-form-input>
                        </b-form-group>
                         -->
                    <b-form-group
                        :label="$t('profile.gender')"
                        label-for="basicSelect"
                        :label-cols="3"
                        >
                        <b-form-select id="basicSelect"
                            :plain="true"
                            :options="options"
                            v-model.trim="$v.form.sex.$model">
                        </b-form-select>
                    </b-form-group>
                    <b-form-group
                        :label="$t('profile.address')"
                        label-for="address"
                        :label-cols="3"
                        >
                        <b-form-input id="address" type="text"  v-model.trim="$v.form.address.$model" ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        :description="$t('profile.email_desc')"
                        :label="$t('profile.email')"
                        label-for="basicEmail"
                        :label-cols="3"
                        >
                        <b-form-input id="basicEmail" type="email" v-model.trim="$v.form.email.$model" autocomplete="email"></b-form-input>
                    </b-form-group>
                    <b-form-group style="display: flex;align-items: center;"
                        :label="$t('profile.can_show')"
                        label-for="can_show"
                        :label-cols="3"
                        >
                        <b-form-checkbox id="can_show" type="text"  v-model.trim="$v.form.can_show.$model"></b-form-checkbox>
                        <div class="error" v-if="submitted && !$v.form.can_show.required">Field is required</div>
                    </b-form-group>
                    <b-form-group
                        :label="$t('profile.created_at')"
                        label-for="created_at"
                        :label-cols="3"
                        >
                        <b-form-input plaintext redonly id="created_at" type="text" :value="form.created_at"></b-form-input>
                    </b-form-group>
                    <div slot="footer">
                        <b-button type="submit" size="md" variant="primary"><i class="fa fa-dot-circle-o"></i> {{ !!validNutritionist ? $t('profile.update') : $t('profile.activate_account') }}</b-button>
                    </div>
                </b-form>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
    import { required } from 'vuelidate/lib/validators';
    import ProfileService from '@/services/profile.service.js';
    import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
    import Nutritionist from '@/store/ORM/nutritionists.js';

    export default {
        name: 'HelloWorld',

        props: {

            msg: String,

            form: Object,

            user: Object,

            validNutritionist: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                isLoading: false,
                submitted: false,
                options: [
                    {value: '', text: this.$t('profile.select_gender')},
                    {value: 'M', text: 'M'},
                    {value: 'F', text: 'F'}
                ],
                first_time: !this.validNutritionist ? 1 : 0
            }
        },

        created(){
            // console.log(this.form);
        },

        validations: {
            form: {
                first_name: {
                    required
                },
                last_name: {
                    required
                },
                // identification:  {
                //   required
                // },
                sex: {
                    required
                },
                address: {
                    required
                },
                whatsapp_nr: {
                // required
                },
                // phone_number:  {
                //   required
                // },
                // dob:  {
                //   required
                // },
                email: {
                    required
                },
                can_show:{}
                // nutritionist:  {
                //   required
                // }
            }
        },

        methods:{

            update(evt){

                evt.preventDefault();

                if(this.$v.form.$invalid){

                    this.$toastr.error( "Required fields need to be completed","ERROR");
                    return;
                }

                this.isLoading = true;
                this.submitted = true;

                ProfileService.updateProfile(this.form.id,this.form).then((res)=>{
                    Nutritionist.update({
                    where: this.form.id,
                    data: {
                        first_name: res.data.nutritionist.first_name,
                        last_name: res.data.nutritionist.last_name,
                        // identification: res.data.nutritionist
                        //   .identification,
                        sex: res.data.nutritionist.sex,
                        address: res.data.nutritionist.address,
                        phone_number: res.data.nutritionist
                        .phone_number,
                        dob: res.data.nutritionist.dob,
                        email: res.data.nutritionist.email,
                        whatsapp_nr : res.data.nutritionist.whatsapp_nr,
                        can_show : res.data.nutritionist.can_show
                    }
                });

                this.$toastr.success(this.$i18n.t('profile.profile_updated'), this.$i18n.t('profile.profile_updated'));

                this.isLoading = false;
                this.submitted = false;

                if(!!this.first_time) {

                    this.$toastr.success(this.$i18n.t('menu.create_first_menu'), this.$i18n.t('menu.create_first_menu'));

                    this.$router.push({name: 'Create Menu'});
                }

                this.first_time = 0;

                },err => {
                    if(err.response.status == 400){

                        if(!!err.response.data.non_field_errors){

                            err.response.data.non_field_errors.forEach((element) => {
                                this.$toastr.error(element,element);
                            });
                        }
                    }else{

                        this.$toastr.error(err.response.statusText, err.response.statusText);
                    }
                });
            }
        },
    }
</script>

<style>
    input:read-only:focus {
        outline-offset: 0px !important;
        outline: 0px !important;
    }
</style>